import type { SubAgentId } from "@/shared/sub-agents";

export interface PlanStep {
  id: string;
  title: string;
  status: "completed" | "in-progress" | "pending";
  owner: string;
}

export interface MockClaimCard {
  id: string;
  insuredName: string;
  claimNumber: string;
  lossType: string;
  status: string;
  priority: "Low" | "Medium" | "High";
  estimatedLoss: string;
  assignedSubAgents: SubAgentId[];
}

export const MOCK_PLAN_STEPS: PlanStep[] = [
  {
    id: "triage",
    title: "Initial triage and policy intake",
    status: "completed",
    owner: "Policy Review Agent"
  },
  {
    id: "media",
    title: "Photo evidence analysis",
    status: "in-progress",
    owner: "Claim Photo Analysis Agent"
  },
  {
    id: "negotiation",
    title: "Mediation strategy prep",
    status: "pending",
    owner: "Mediation Expert Agent"
  }
];

export const MOCK_CLAIMS: MockClaimCard[] = [
  {
    id: "1",
    insuredName: "Jordan Ramirez",
    claimNumber: "CM-2026-00412",
    lossType: "Water Damage",
    status: "Documentation Requested",
    priority: "High",
    estimatedLoss: "$42,600.00",
    assignedSubAgents: ["policy-review", "coverage-gap"]
  },
  {
    id: "2",
    insuredName: "Priya Singh",
    claimNumber: "CM-2026-00177",
    lossType: "Fire/Smoke",
    status: "Carrier Review",
    priority: "Medium",
    estimatedLoss: "$118,250.00",
    assignedSubAgents: ["claim-photo-analysis", "mediation-expert"]
  }
];
